import Vue from "vue"
import { VueQueryPlugin } from "@tanstack/vue-query"

Vue.use(VueQueryPlugin)
